<template>
  <div class="blue-grey lighten-5" fluid style="max-width: 100vw">
    <v-row cols="12" justify="center">
      <p class="head">価格について</p>
    </v-row>
    <v-row cols="12" justify="center">
      <p class="sub">PRICE</p>
    </v-row>
    <v-row cols="12" justify="center">
      <div class="price_icon">
        <img src="../assets/price.svg" width=40px>
      </div>
    </v-row>
    

    <v-row justify="center" class="mt-1">
      <v-col align="center" cols=12>
        <v-sheet
          class="py-4"
          width="600"
          color="teal"
        >
          <p class="price">
            「けんぽのホームページ」導入<span class="price2"><b>150,000</b>円（税別）</span>
            <br>月額利用料<span class="price3"><b>25,000</b>円（税別）</span>
         </p>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col align="center" cols=12>
        <p class="text">
          <br>イージーオーダーでつくるHPだから
          <br>とってもラクチン、とっても安い！
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'Price',

    data: () => ({

    }),
  }
</script>

<style scoped>
  .head {
    position: relative;
    font-size: 30px;
    letter-spacing: 0.1em;
  }

  .head:before {
    content: '';
    position: absolute;
    bottom: -10px;
    display: inline-block;
    width: 350px;
    height: 1px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color: black;
    border-radius: 2px;
  }
  .sub{
    color:#808080;
    font-size: 18px;
    letter-spacing: 0.1em;
  }
  .text{
    margin-top: 0px;
    letter-spacing: 0.2em;
    font-size: 20px;
    line-height: 2em;
  }
  .price{
    color:#FFF; 
    margin-top: 10px;
    letter-spacing: 0.1em;
    font-size: 20px;
  }
  .price2{
    margin-left: 20px;
  }
  .price3{
    margin-left: 210px;
  }
  .price_icon {
    position: relative;
    width: 60px;
    top: -53px;
    right: -170px;
  }

</style>
